import React from 'react';
import {injectIntl} from 'react-intl';
import { Row, Col, Panel } from 'react-bootstrap';

import {BMC_BLOCKS} from '../common_components/bmc/bmc_constants';
import BmcBlockIcon from '../common_components/bmc/BmcBlockIcon';
import { observer } from 'mobx-react';


@observer
class BlockHeader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {blockStore, intl} = this.props;
        return (
    
            <div className="lane-header">
                <h4 style={{display: 'inline-block'}}>
                    <BmcBlockIcon block={blockStore.name} />&nbsp;
                    {intl.formatMessage({id: "IgbmcBoard-"+blockStore.name})}
                </h4>
                <h5 style={{display: 'inline-block', float: 'right'}}>{blockStore.cardsLength}</h5>
            </div>
    
        );
    }
}

export default injectIntl(BlockHeader);